module.exports = __webpack_public_path__ + "static/media/user-new.7a21cbe9.svg";